mutation CreateHifoCascadePitch(
  $hifoCascadeId: ID!
  $hifoCascadePitchInput: HifoCascadePitchChangeInput!
) {
  createHifoCascadePitch(
    input: {
      hifoCascadeId: $hifoCascadeId
      hifoCascadePitchInput: $hifoCascadePitchInput
    }
  ) {
    hifoCascadePitch {
      id
    }
  }
}
